<template>
    <div>
        <v-card color="transparent" flat>

            <v-card-title>
                {{statName}}
            </v-card-title>

            <v-card-text>

                Thread pool queue utilization

                {{ stats.queue }} / {{ stats.queue_size }}

                <v-progress-linear striped color="primary"
                                   :height="15"
                                   :value="Math.round(stats.queue / stats.queue_size * 100)"/>
            </v-card-text>
        </v-card>

        <v-card color="transparent" flat>
            <v-card-text>

                Thread pool threads active

                {{ stats.active }} / {{ stats.threads }}

                <v-progress-linear striped
                                   color="primary"
                                   :height="15"
                                   :value="Math.round(stats.active / stats.queue_threads * 100)"/>
            </v-card-text>
        </v-card>
        <v-container fluid>
            <v-row dense>
                <v-col cols="6">

                    <stat-box-numerical hint="Max threads used"
                                        :value="stats.largest">

                    </stat-box-numerical>
                </v-col>

                <v-col cols="6">
                    <stat-box-numerical hint="Rejected"
                                        :value="stats.rejected">

                    </stat-box-numerical>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>


import StatBoxNumerical from "../../../components/UI/StatBoxNumerical";

export default {

    name: "NodeStats",

    components: {
        StatBoxNumerical
    },

    props: {
        stats: {
            type: Object,
            required: true,
        },
        statName: {
            type: String,
            required: true
        }
    }

}
</script>
